const setupToastr = () => {
  const default_width = 300;

  const style_sheet = document.createElement('style');

  if (window.theme.notification.width !== default_width && window.theme.notification.width !== '') {
    style_sheet.innerText = `#toast-container > div { width: ${window.theme.notification.width}px; }`;
    document.head.appendChild(style_sheet);
  }

  if ($('body').hasClass('template-product') && !window.theme.notification.enabledMobilePDP) {
    style_sheet.innerText = '.toast-bottom-right { display: none; }';
    document.head.appendChild(style_sheet);
  }

  // https://codeseven.github.io/toastr/demo.html
  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    progressBar: window.theme.notification.showProgressBar, // Visually indicate how long before a toast expires
    positionClass: (window.theme.breakpoints.current === 'mobile') ? 'toast-bottom-right' : 'toast-top-right',
    preventDuplicates: true,
    onclick: null,
    showDuration: 300,
    hideDuration: 400,
    timeOut: window.theme.notification.timeout, // How long the toast will display without user interaction
    extendedTimeOut: 0, // How long the toast will display after a user hovers over it
    showEasing: 'linear',
    hideEasing: 'linear',
    showMethod: 'slideDown',
    hideMethod: 'fadeOut',
  };

  toastr.options.onCloseClick = () => {
    window.localStorage.setItem('wild-notification-status', 'closed');
    window.localStorage.setItem('wild-notification-expires', Date.now() + (window.theme.notification.keepHiddenDays * 86400000));
  };
  toastr.options.onclick = () => {
    window.localStorage.setItem('wild-notification-status', 'closed');
    window.localStorage.setItem('wild-notification-expires', Date.now() + (window.theme.notification.keepHiddenDays * 86400000));
  };

  toastr.info(window.theme.notification.contentHTML, window.theme.notification.title);

  // Third party z-index (top of collection elements, footer, nav)
  $('#INDWrap').css('z-index', 6);

  $(window).on('breakpointHasChanged', (e, current_breakpoint) => {
    if (!$('#toast-container').length) {
      return;
    }

    $('#toast-container').removeAttr('class').removeAttr('style');
    (current_breakpoint === 'mobile') ? $('#toast-container').addClass('toast-bottom-right') : $('#toast-container').addClass('toast-top-right');
    $(window).trigger('scroll');
  });

  $(window).trigger('scroll');

  window.localStorage.setItem('wild-notification-status', 'opened');
};

const stickyNotification = () => {
  $(window).on('scroll', _.debounce(() => {
    if (window.theme.breakpoints.current === 'mobile' || !$('.toast-top-right').length) {
      return;
    }

    let new_top = $('[data-header]').outerHeight() + $('[data-main-nav]').outerHeight();
    new_top += $('body').hasClass('.no-announcement') ? 0 : ($('.announcement-bar').length ? $('.announcement-bar').outerHeight() : 0);

    if ($('.main-nav--desktop').hasClass('sticky')) {
      new_top = $('[data-header]').outerHeight() + $('[data-main-nav]').outerHeight();

      if ($('.main-nav--desktop').hasClass('header-hidden')) {
        new_top = $('[data-main-nav]').outerHeight();
      }
    }

    $('.toast-top-right').css('top', new_top + 50);
  }));
};

const checkNotificationStatus = () => {
  // Don't show the notification on the 1st page visited
  const pages_viewed = (window.sessionStorage.getItem('wild-pages-viewed') === null) ? 1 : Number(window.sessionStorage.getItem('wild-pages-viewed'));
  if (pages_viewed === 1) {
    return false;
  }

  const notification_status = window.localStorage.getItem('wild-notification-status');
  const notification_expires = window.localStorage.getItem('wild-notification-expires');
  if (notification_status === 'closed') {
    if (notification_expires === null) {
      return true;
    }

    return (Date.now() > Number(notification_expires));
  } else {
    return true;
  }
};

export default () => {
  if (!window.theme.notification.enabled || (!window.theme.notification.contentHTML.length && !window.theme.notification.title.length) || !checkNotificationStatus()) {
    return;
  }

  // Show the Toast after a delay setup by the user
  window.setTimeout(() => {
    setupToastr();
    stickyNotification();
  }, window.theme.notification.showafter * 1000);
};
